// Contact form (/kontakt/). Checks the fields, loads reCAPTCHA v3 once the
// visitor starts filling the form in (not with the page: it's heavy), and on
// submit gets a token and posts the form to app.goshop.pl. The lead is
// counted on the thank-you page (form-sent.njk) that the backend redirects
// to after accepting the message, not on each click of the button.
const EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
// Read and removed by the thank-you page; same key there.
const LEAD = 'gs_contact_lead';

// Enhanced conversions: the e-mail or the phone number (+48 by default)
const userData = (value) => {
  let contact = value.replace(/\s/g, '');
  if (EMAIL.test(contact)) return { email: contact.toLowerCase() };
  if (/^\+?[0-9]{9,15}$/.test(contact)) {
    if (!contact.startsWith('+')) contact = `+48${contact}`;
    return { phone_number: contact };
  }
  return {};
};

const storeLead = (value) => {
  try {
    if (value === null) sessionStorage.removeItem(LEAD);
    else sessionStorage.setItem(LEAD, JSON.stringify(value));
  } catch (e) {
    // No sessionStorage: the message still goes, just isn't counted.
  }
};

export default function contactForm() {
  const form = document.getElementById('contact-form');
  if (!form) return;
  // Back on the form after an attempt that didn't reach the thank-you page
  storeLead(null);

  const key = form.dataset.recaptchaKey;
  const error = form.querySelector('.contact-form__error');
  const fields = ['form-name', 'form-email', 'form-message'].map((name) => form.elements[name]);
  // Without this script the browser's own checks (required, minlength) apply.
  form.noValidate = true;

  let recaptcha;
  const loadRecaptcha = () => {
    if (!recaptcha) {
      recaptcha = new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${key}`;
        script.async = true;
        script.onload = () => window.grecaptcha.ready(resolve);
        script.onerror = resolve;
        document.head.appendChild(script);
      });
    }
    return recaptcha;
  };
  form.addEventListener('focusin', loadRecaptcha, { once: true });

  const check = (field) => {
    const valid = field.value.trim().length >= 2 && field.value.length <= 10000;
    if (valid) field.removeAttribute('aria-invalid');
    else field.setAttribute('aria-invalid', 'true');
    return valid;
  };
  // Once flagged, a field clears its error as soon as it's fixed.
  fields.forEach((field) =>
    field.addEventListener('input', () => {
      if (field.hasAttribute('aria-invalid')) check(field);
    })
  );

  let submitting = false;
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const invalid = fields.filter((field) => !check(field));
    error.hidden = invalid.length === 0;
    if (invalid.length) {
      invalid[0].focus();
      return;
    }
    if (submitting) return;
    submitting = true;

    storeLead(userData(form.elements['form-email'].value));

    // Post once the reCAPTCHA token is there, or after 5 s: never lose a
    // message because of a blocked script. The token is valid for 2 minutes
    // only, so it's requested now.
    let posted = false;
    const post = () => {
      if (posted) return;
      posted = true;
      form.submit();
    };
    setTimeout(post, 5000);
    loadRecaptcha().then(() => {
      if (!window.grecaptcha) {
        post();
        return;
      }
      window.grecaptcha.execute(key, { action: 'contact' }).then((token) => {
        form.elements.recaptcha_response.value = token;
        post();
      }, post);
    });
  });
}
